import { v4 as uuidv4 } from 'uuid';
import { DEFAULT_SESSION_TTL } from '@/lib/consts/session';

const SESSION_ID_COOKIE = 'session_id';

class SessionManager {
    private cachedSessionId: string | null = null;

    initialize() {
        this.getOrCreateSessionId();
    }

    getSessionId(): string | null {
        if (this.cachedSessionId) {
            return this.cachedSessionId;
        }

        if (typeof document !== 'undefined') {
            const sessionId = this.getCookieValue(SESSION_ID_COOKIE);
            if (sessionId) {
                this.cachedSessionId = sessionId;
            }
            return sessionId;
        }

        return null;
    }

    getOrCreateSessionId(): string {
        let sessionId = this.getSessionId();

        if (!sessionId && typeof document !== 'undefined') {
            sessionId = uuidv4();
            this.setSessionIdCookie(sessionId);
            this.cachedSessionId = sessionId;
        }

        return sessionId || '';
    }

    private setSessionIdCookie(sessionId: string): void {
        if (typeof document === 'undefined') return;

        const maxAge = DEFAULT_SESSION_TTL / 1000;
        const secure = process.env.NODE_ENV === 'production' ? '; Secure' : '';

        document.cookie = `${SESSION_ID_COOKIE}=${sessionId}; path=/; max-age=${maxAge}; SameSite=Lax${secure}`;
    }

    clearSessionId(): void {
        this.cachedSessionId = null;

        if (typeof document !== 'undefined') {
            document.cookie = `${SESSION_ID_COOKIE}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
        }
    }

    private getCookieValue(name: string): string | null {
        if (typeof document === 'undefined') return null;

        const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
        return match ? match[2] : null;
    }
}

export const sessionManager = new SessionManager();
export const SESSION_ID_COOKIE_NAME = SESSION_ID_COOKIE;
